module.exports = __webpack_public_path__ + "static/bind.7ca6e681.png";